// extracted by mini-css-extract-plugin
export default {"button":"GraphFooter_button__JppZP","input":"GraphFooter_input__-t3gA","container":"GraphFooter_container__eohv6","dataAttribution":"GraphFooter_dataAttribution__8FCC5"};